// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"05ce93af5bad27ba2879","303":"43b90c2c545174d86a82","495":"a801f2a72b7825a0b228"}[chunkId] + ".js";
};